import React, { useState, useEffect } from 'react'
import Container from '../../container/container'
import { useTranslation } from 'react-i18next';
import teamStyles from './team.module.scss'
import { Phone, Mail, Linkedin } from "lucide-react";

const teamMembers = [
  {
    image: 'engKhalid.svg',
    name: 'Khalid AlGhamdi',
    position: 'President',
    phone: +966542787001,
    email: 'khalid.al-ghamdi@arabtechco.sa',
    linkedin: '',
  },
  {
    image: 'engShawky.svg',
    name: 'Ahmed Shawky',
    position: 'Executive Manager',
    phone: +966565840010,
    email: 'ahmed.shawky@arabtechco.sa',
    linkedin: 'ahmed-shawky-b55912104/',
  },
  {
    image: 'mrAhmed.svg',
    name: 'Ahmed AbdElSalam',
    position: 'Accounting Manager',
    phone: '',
    email: 'accounts@arabtechco.sa',
    linkedin: 'ahmed-abdelsalam/',
  },
  {
    image: 'mrAhmedHamed.svg',
    name: 'Ahmed Hamed',
    position: 'Chief Account Department',
    phone: +966582889484,
    email: 'ahmed.hamed@arabtechco.sa',
    linkedin: '',
  },
  {
    image: 'engHamid.svg',
    name: 'Hamid Gulzar',
    position: 'Engineering & Technical Department',
    phone: +966593175330,
    email: 'hamid.ali@arabtechco.sa',
    linkedin: 'hamid-gulzar-106b7050/',
  },
  {
    image: 'engMustafa.svg',
    name: 'Mustafa Hussein',
    position: 'Field Services Manager',
    phone: +966500093378,
    email: 'mustafa.hussien@arabtechco.sa',
    linkedin: 'mostafa-hussen-88392949/',
  },
  {
    image: 'engHany.jpeg',
    name: 'Hany Ramadan',
    position: 'Projects Manager',
    phone: +966507474071,
    email: 'hany.ramadan@arabtechco.sa',
  },
  {
    image: 'engTarek.png',
    name: 'Tarek Hassan',
    position: 'Procurement and Contracts Manager',
    phone: +966546090329,
    email: 'tarek.hasan@arabtechco.sa',
    linkedin: 'tarek-hamada-03176051/',
  },
  {
    image: 'engZahid.svg',
    name: 'Zahid Gulzar',
    position: 'Head of Tendering Department',
    phone: +966542768957,
    email: 'zahid.gulzar@arabtechco.sa',
    linkedin: 'zahid-gulzar-86258b307/',
  },
  {
    image: 'engRami.svg',
    name: 'Rami AlGhamdi',
    position: 'Public Relations Coordinator',
    phone: +966555112406,
    email: 'rami.alghamdi@arabtechco.sa',
    linkedin: 'rami-alghamdi-401842182/',
  },
  {
    image: 'mrRonald.svg',
    name: 'Ronald Nicasio',
    position: 'Administration Manager',
    phone: +966565492704,
    email: 'admin@arabtechco.sa',
    linkedin: 'ronaldo-nicasio-0386a029a/',
  },
]

const teamMembers_ar = [
  {
    image: 'engKhalid.svg',
    name: 'خالد الغامدي',
    position: 'المدير العام',
    phone: +966542787001,
    email: 'khalid.al-ghamdi@arabtechco.sa',
    linkedin: '',
  },
  {
    image: 'engShawky.svg',
    name: 'أحمد شوقي',
    position: 'المدير التنفيذي',
    phone: +966565840010,
    email: 'ahmed.shawky@arabtechco.sa',
    linkedin: 'ahmed-shawky-b55912104/',
  },
  {
    image: 'mrAhmed.svg',
    name: 'أحمد عبدالسلام',
    position: 'مدير المحاسبة',
    phone: '',
    email: 'accounts@arabtechco.sa',
    linkedin: 'ahmed-abdelsalam/',
  },
  {
    image: 'engHamid.svg',
    name: 'حميد جولزار',
    position: 'قسم الهندسة والتقنية',
    phone: +966593175330,
    email: 'hamid.ali@arabtechco.sa',
    linkedin: 'hamid-gulzar-106b7050/',
  },
  {
    image: 'engMustafa.svg',
    name: 'مصطفى حسين',
    position: 'مدير الخدمات الميدانية',
    phone: +966500093378,
    email: 'mustafa.hussien@arabtechco.sa',
    linkedin: 'mostafa-hussen-88392949/',
  },
  {
    image: 'engHany.jpeg',
    name: 'هاني رمضان',
    position: 'مدير مشاريع',
    phone: +966507474071,
    email: 'hany.ramadan@arabtechco.sa',
  },
  {
    image: 'engTarek.png',
    name: 'طارق حسن',
    position: 'مدير المشتريات والعقود',
    phone: +966546090329,
    email: 'tarek.hasan@arabtechco.sa',
    linkedin: 'tarek-hamada-03176051/',
  },
  {
    image: 'engZahid.svg',
    name: 'زاهد جولزار',
    position: 'رئيس قسم المناقصات',
    phone: +966542768957,
    email: 'zahid.gulzar@arabtechco.sa',
    linkedin: 'zahid-gulzar-86258b307/',
  },
  {
    image: 'engRami.svg',
    name: 'رامي الغامدي',
    position: 'منسق العلاقات العامة',
    phone: +966555112406,
    email: 'rami.alghamdi@arabtechco.sa',
    linkedin: 'rami-alghamdi-401842182/',
  },
  {
    image: 'mrRonald.svg',
    name: 'رونالد نيكاسيو',
    position: 'مدير الإدارة',
    phone: +966565492704,
    email: 'admin@arabtechco.sa',
    linkedin: 'ronaldo-nicasio-0386a029a/',
  },
]

export default function Team() {
  const { t, i18n } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
  const [activeCard, setActiveCard] = useState(null);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  const toggleCard = (index) => {
    if (activeCard === index) {
      setActiveCard(null);
    } else {
      setActiveCard(index);
    }
  };

  const currentTeam = i18n.language === 'en' ? teamMembers : teamMembers_ar;

  return (
    <Container>
      <h1 className="title">{t('teamTitle')}</h1>

      <div className={`${teamStyles.teamContainer} ${i18n.language === 'ar' ? teamStyles.teamContainer_ar : ''}`}>
        {currentTeam.map((t, index) => (
          <div
            key={index}
            className={`${teamStyles.memberCard} ${activeCard === index ? teamStyles.active : ''}`}
            onClick={() => isMobile && toggleCard(index)}
            onMouseEnter={() => !isMobile && setActiveCard(index)}
            onMouseLeave={() => !isMobile && setActiveCard(null)}
          >
            <Member
              image={t.image}
              name={t.name}
              job={t.position}
              phone={t.phone}
              email={t.email}
              linkedin={t.linkedin}
              isActive={activeCard === index}
              isMobile={isMobile}
              language={i18n.language}
            />
          </div>
        ))}
      </div>
    </Container>
  )
}

function Member({ image, name, job, phone, email, linkedin, isActive, isMobile, language }) {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <>
      <div className={teamStyles.memberPhoto}>
        <div className={`${teamStyles.skeleton} ${imageLoaded ? teamStyles.hidden : ''}`}></div>
        <img
          src={`../images/team/${image}`}
          alt={name}
          onLoad={() => setImageLoaded(true)}
          className={imageLoaded ? teamStyles.loaded : ''}
          loading="lazy"
        />
      </div>
      <div className={teamStyles.info}>
        <h2>{name}</h2>
        <h3>{job}</h3>
      </div>
      <div className={`${teamStyles.social} ${isActive ? teamStyles.active : ''}`}>
        {phone && (
          <a href={`tel:${phone}`} target='_blank' rel="noopener noreferrer" aria-label={`Call ${name}`}>
            <Phone size={16} />
          </a>
        )}
        <a href={`mailto:${email}`} target='_blank' rel="noopener noreferrer" aria-label={`Email ${name}`}>
          <Mail size={16} />
        </a>
        {linkedin && (
          <a href={`https://www.linkedin.com/in/${linkedin}`} target='_blank' rel="noopener noreferrer" aria-label={`LinkedIn ${name}`}>
            <Linkedin size={16} />
          </a>
        )}
      </div>
      {isMobile && (
        <div className={teamStyles.mobileToggle}>
          <span>{isActive ? '▲' : '▼'}</span>
        </div>
      )}
    </>
  )
}